'use strict';
// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/array-buffer-basic-detection.js
// module id = 376
// module chunks = 0